import { orbitRingOf, orbitRingRadius, RING_SLOTS, type OrbitLayout } from "./settings.ts";

/**
 * Where a participant's orbit is in its rotation, on the *simulation* clock.
 *
 * Both ends must agree. The server picked the launch point from its own tick clock
 * while the browser drew the spheres from `requestAnimationFrame` — unrelated
 * clocks, so a shot left from an angle that had nothing to do with the sphere you
 * were looking at. The per-participant offset keeps orbits from spinning in unison
 * and is derived from the id, so the server can reproduce it exactly.
 */
export function orbitPhaseFor(id: string, timeSeconds: number) {
  let hash = 0;
  for (let index = 0; index < id.length; index += 1) hash = (hash * 31 + id.charCodeAt(index)) | 0;
  return timeSeconds + (Math.abs(hash) % 1000) / 1000 * Math.PI * 2;
}

/** Each ring turns a little slower than the one inside it, and the other way round. */
const RING_SPIN = [1.25, -0.85, 0.62];

export function getOrbitPosition(
  coreX: number,
  coreY: number,
  index: number,
  time: number,
  layout: OrbitLayout,
) {
  const ring = orbitRingOf(index);
  const slot = index - ring * RING_SLOTS;
  const radius = orbitRingRadius(ring, layout);
  const angle = (slot / RING_SLOTS) * Math.PI * 2 + time * RING_SPIN[ring];
  return {
    x: coreX + Math.cos(angle) * radius,
    y: coreY + Math.sin(angle) * radius,
    angle,
  };
}
